module.exports = __webpack_public_path__ + "img/jaden.f793f42c.jpg";